import API from "../../../app/api";

export const getmycollection = async () => {
  try {
    const res = await API.get("/banners");
    if (res.data?.success) {
      return res.data?.data?.bottom?.banners || [];
    }
    return [];
  } catch (error) {
    console.error("My collection Error:", error);
    return [];
  }
};
